import { render, staticRenderFns } from "./PasswordResetMailInputSection.vue?vue&type=template&id=0ade34b8&scoped=true"
import script from "./PasswordResetMailInputSection.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMailInputSection.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetMailInputSection.vue?vue&type=style&index=0&id=0ade34b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ade34b8",
  null
  
)

export default component.exports